var map = {
	"./bereavement/Modules/bereavementInTheWorkplace": 3035,
	"./bereavement/Modules/bereavementInTheWorkplace.jsx": 3035,
	"./bereavement/Modules/cpd-certificate": 1587,
	"./bereavement/Modules/cpd-certificate.jsx": 1587,
	"./bereavement/Modules/supportIfAColleagueDies": 9143,
	"./bereavement/Modules/supportIfAColleagueDies.jsx": 9143,
	"./bereavement/Modules/supportingABereavedColleague": 2379,
	"./bereavement/Modules/supportingABereavedColleague.jsx": 2379,
	"./bereavement/Modules/useful-links-and-sources": 8543,
	"./bereavement/Modules/useful-links-and-sources.jsx": 8543,
	"./bereavement/Modules/whatIsBereavement": 7311,
	"./bereavement/Modules/whatIsBereavement.jsx": 7311,
	"./bereavement/Modules/workingThroughBereavement": 2000,
	"./bereavement/Modules/workingThroughBereavement.jsx": 2000,
	"./cancerInTheWorkplace/Modules/biotherapy": 6001,
	"./cancerInTheWorkplace/Modules/biotherapy.jsx": 6001,
	"./cancerInTheWorkplace/Modules/chemotherapy": 4300,
	"./cancerInTheWorkplace/Modules/chemotherapy.jsx": 4300,
	"./cancerInTheWorkplace/Modules/cpd-certificate": 1598,
	"./cancerInTheWorkplace/Modules/cpd-certificate.jsx": 1598,
	"./cancerInTheWorkplace/Modules/overview": 7550,
	"./cancerInTheWorkplace/Modules/overview.jsx": 7550,
	"./cancerInTheWorkplace/Modules/psychologicalSideEffects": 3328,
	"./cancerInTheWorkplace/Modules/psychologicalSideEffects.jsx": 3328,
	"./cancerInTheWorkplace/Modules/radiotherapy": 5301,
	"./cancerInTheWorkplace/Modules/radiotherapy.jsx": 5301,
	"./cancerInTheWorkplace/Modules/supportingYourStaff": 5237,
	"./cancerInTheWorkplace/Modules/supportingYourStaff.jsx": 5237,
	"./cancerInTheWorkplace/Modules/surgery": 1853,
	"./cancerInTheWorkplace/Modules/surgery.jsx": 1853,
	"./cancerInTheWorkplace/Modules/useful-links-and-sources": 4994,
	"./cancerInTheWorkplace/Modules/useful-links-and-sources.jsx": 4994,
	"./cancerInTheWorkplace/Modules/whatIsCancer": 1849,
	"./cancerInTheWorkplace/Modules/whatIsCancer.jsx": 1849,
	"./mentalHealth/Modules/cpd-certificate": 5188,
	"./mentalHealth/Modules/cpd-certificate.jsx": 5188,
	"./mentalHealth/Modules/developingAStrategy": 1753,
	"./mentalHealth/Modules/developingAStrategy.jsx": 1753,
	"./mentalHealth/Modules/howToSupportAnEmployee": 3984,
	"./mentalHealth/Modules/howToSupportAnEmployee.jsx": 3984,
	"./mentalHealth/Modules/supportingAnAbsentEmployee": 9165,
	"./mentalHealth/Modules/supportingAnAbsentEmployee.jsx": 9165,
	"./mentalHealth/Modules/supportingTheTeamAndYourself": 4440,
	"./mentalHealth/Modules/supportingTheTeamAndYourself.jsx": 4440,
	"./mentalHealth/Modules/theMentalHealthContinuum": 2978,
	"./mentalHealth/Modules/theMentalHealthContinuum.jsx": 2978,
	"./mentalHealth/Modules/useful-links-and-sources": 7859,
	"./mentalHealth/Modules/useful-links-and-sources.jsx": 7859,
	"./mentalHealth/Modules/whatIsMentalHealth": 6773,
	"./mentalHealth/Modules/whatIsMentalHealth.jsx": 6773,
	"./mentalHealth/Modules/whatLineManagersNeedToKnow": 5450,
	"./mentalHealth/Modules/whatLineManagersNeedToKnow.jsx": 5450,
	"./mentalHealth/Modules/yourRoleAsLineManager": 6599,
	"./mentalHealth/Modules/yourRoleAsLineManager.jsx": 6599,
	"./musculoskeletalDisorders/Modules/backPain": 5424,
	"./musculoskeletalDisorders/Modules/backPain.jsx": 5424,
	"./musculoskeletalDisorders/Modules/cpd-certificate": 1383,
	"./musculoskeletalDisorders/Modules/cpd-certificate.jsx": 1383,
	"./musculoskeletalDisorders/Modules/preventingMSDs": 6546,
	"./musculoskeletalDisorders/Modules/preventingMSDs.jsx": 6546,
	"./musculoskeletalDisorders/Modules/psychologicalImpactOfMSDs": 595,
	"./musculoskeletalDisorders/Modules/psychologicalImpactOfMSDs.jsx": 595,
	"./musculoskeletalDisorders/Modules/supportingAnEmployee": 207,
	"./musculoskeletalDisorders/Modules/supportingAnEmployee.jsx": 207,
	"./musculoskeletalDisorders/Modules/useful-links-and-sources": 79,
	"./musculoskeletalDisorders/Modules/useful-links-and-sources.jsx": 79,
	"./musculoskeletalDisorders/Modules/whatAreCommonMSDs": 774,
	"./musculoskeletalDisorders/Modules/whatAreCommonMSDs.jsx": 774,
	"./musculoskeletalDisorders/Modules/whatIsAnMSD": 2346,
	"./musculoskeletalDisorders/Modules/whatIsAnMSD.jsx": 2346,
	"./sicknessAbsence/Modules/cpd-certificate": 8062,
	"./sicknessAbsence/Modules/cpd-certificate.jsx": 8062,
	"./sicknessAbsence/Modules/preventingSicknessAbsence": 6781,
	"./sicknessAbsence/Modules/preventingSicknessAbsence.jsx": 6781,
	"./sicknessAbsence/Modules/supportingAnEmployeeDuringAbsence": 8012,
	"./sicknessAbsence/Modules/supportingAnEmployeeDuringAbsence.jsx": 8012,
	"./sicknessAbsence/Modules/supportingAnEmployeesReturnToWork": 9716,
	"./sicknessAbsence/Modules/supportingAnEmployeesReturnToWork.jsx": 9716,
	"./sicknessAbsence/Modules/useful-links-and-sources": 1774,
	"./sicknessAbsence/Modules/useful-links-and-sources.jsx": 1774,
	"./sicknessAbsence/Modules/whatElseDoYouNeedToKnow": 1516,
	"./sicknessAbsence/Modules/whatElseDoYouNeedToKnow.jsx": 1516,
	"./sicknessAbsence/Modules/whyManageAbsence": 4996,
	"./sicknessAbsence/Modules/whyManageAbsence.jsx": 4996,
	"./stressAwareness/Modules/covid19AndStress": 3321,
	"./stressAwareness/Modules/covid19AndStress.jsx": 3321,
	"./stressAwareness/Modules/cpd-certificate": 1572,
	"./stressAwareness/Modules/cpd-certificate.jsx": 1572,
	"./stressAwareness/Modules/keepingYouAndYourTeamHealthy": 4711,
	"./stressAwareness/Modules/keepingYouAndYourTeamHealthy.jsx": 4711,
	"./stressAwareness/Modules/managingStressRelatedProblems": 1913,
	"./stressAwareness/Modules/managingStressRelatedProblems.jsx": 1913,
	"./stressAwareness/Modules/recognisingStress": 3539,
	"./stressAwareness/Modules/recognisingStress.jsx": 3539,
	"./stressAwareness/Modules/useful-links-and-sources": 9477,
	"./stressAwareness/Modules/useful-links-and-sources.jsx": 9477,
	"./stressAwareness/Modules/whatIsStress": 3573,
	"./stressAwareness/Modules/whatIsStress.jsx": 3573,
	"./stressAwareness/Modules/whyManageStress": 6262,
	"./stressAwareness/Modules/whyManageStress.jsx": 6262,
	"./stressAwareness/Modules/yourRoleAsALineManager": 2858,
	"./stressAwareness/Modules/yourRoleAsALineManager.jsx": 2858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7895;